import './App.css';
import { Grid, Button } from '@mui/material';
import Logo from './Logo.png';
import Untitled from './Untitled.png';

export default () => {
  return (
    <Grid
      container
      spacing={0}
      direction="column"
      alignItems="center"
      justifyContent="center"
      style={{ minHeight: '100vh' }}
    >
      <Grid
        container
        xs={12}
        alignItems="center"
        justifyContent="center"
        style={{
          position: 'relative',
          marginBottom: 20,
          flexDirection: 'column'
        }}
      >
        <img src={Logo} width={150} style={{imageRendering: 'crisp-edges', zIndex: 2}}></img>
        <img src={Untitled} width={256} style={{imageRendering: 'pixelated', zIndex: 2, borderRadius: 5, marginTop: 10}}></img>
        <Button
          variant="contained"
          color="primary"
          href="https://play.canvaslegacyrewritten.com"
          target="_blank"
          rel="noopener noreferrer"
          style={{ marginTop: 16 }}
        >
          Play Now
        </Button>
      </Grid>
    </Grid> 
  );
};
